import React from 'react'

export default function EmployeesDashboard() {
  return (
    <div>EmployeesDashboard</div>
  )
}
